var map = {
	"./partner1.png": "f0c7",
	"./partner10.png": "c576",
	"./partner11.png": "8697",
	"./partner12.png": "12ee",
	"./partner2.png": "b131",
	"./partner3.png": "6142",
	"./partner4.png": "38cd",
	"./partner5.png": "e3ef",
	"./partner6.png": "b8af",
	"./partner7.png": "a1df",
	"./partner8.png": "0919",
	"./partner9.png": "e364"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebe1";